module.exports = __webpack_public_path__ + "img/Plus.70e3b8b0.jpg";